import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import { connect } from "react-redux";
// import { MDBDataTable } from "mdbreact";
// import HourlyStatus from "../DeviceData/HourlyStatus";
import TypeNav from "../DeviceData/TypeNav";
// import Pagination from "../../Common/Pagination";
import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
import * as actions from "../../../stores/actions/index";
import Alarm from "../DeviceData/Alarm";
import { LoopCircleLoading } from "react-loadingg";
import moment from "moment";
// Constants
import { APP_COLORS } from "../../Common/constants";
import "./index.styles.scss";

import HC_exporting from "highcharts/modules/exporting";

// import Intervals from "./Interval";
// import { dispatch } from "d3";
import { apiPath } from "../../../config/config";
import { translate } from "react-i18next";
import { getCommonHeaders } from "../../../utils/utilities";

HC_exporting(Highcharts);

const color0 = [
  "rgba(239, 83, 80, 0)",
  "rgba(52, 152, 219, 0)",
  "rgba(241, 196, 15, 0)",
];
const menuOptions = [
  "viewFullscreen",
  "printChart",
  "separator",
  "downloadPNG",
  "downloadJPEG",
  "downloadPDF",
  "downloadSVG",
];
class DeviceData extends React.Component {
  state = {
    showGraph: false,
    basicData: "",
    // chartLoaded: false,
    chartOptions: {
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        sourceWidth: 2000,
        buttons: {
          contextButton: {
            menuItems: menuOptions,
          },
        },
      },
      navigation: {
        buttonOptions: {
          align: "right",
          verticalAlign: "top",
          y: 0,
        },
      },
      chart: {
        // events: {
        //   redraw: () => {
        //     console.info("red");
        //     // this.checkChartLoaded(false);
        //   },

        //   load: () => {
        //     console.info("load");
        //     // this.checkChartLoaded(false);
        //   },
        //   render: () => {
        //     console.info("hellp");
        //     // this.checkChartLoaded(false);
        //   },
        // },
        backgroundColor: APP_COLORS["gray-darker"],
        scrollablePlotArea: {
          minWidth: 2000,
          scrollPositionX: 1,
          opacity: 0.1,
        },
        zoomType: "x",
        resetZoomButton: {
          position: {
            x: -40,
            y: 10,
          },
          relativeTo: "chart",
          theme: {
            fill: "white",
            stroke: "silver",
            r: 0,
            states: {
              hover: {
                fill: "#41739D",
                style: {
                  color: "white",
                },
              },
            },
          },
        },
        animation: Highcharts.svg,
      },
      series: [
        {
          type: "areaspline",
          name: "Humidity",
          color: APP_COLORS["blue-light"],
          data: [],
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, APP_COLORS["blue-light"]],
              [0.35, APP_COLORS["blue-dark"]],
              [1, color0[1]],
            ],
          },
        },
        {
          type: "areaspline",
          name: "Temperature",
          color: APP_COLORS["red"],
          data: [],

          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, APP_COLORS["red"]],
              [0.25, APP_COLORS["red-dark"]],
              [1, color0[0]],
            ],
          },
        },
        {
          type: "areaspline",
          name: "CO₂",
          color: APP_COLORS["yellow"],
          data: [],
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, APP_COLORS["yellow"]],
              [0.15, APP_COLORS["yellow-dark"]],
              [1, color0[2]],
            ],
          },
        },
      ],
      xAxis: {
        type: "datetime",
        categories: [],
        tickPixelInterval: null,
        // reversed: true,
      },
      yAxis: {
        visible: true,
        tickWidth: 1,
        gridLineWidth: 0,
        labels: {
          style: {
            color: "#fff",
          },
        },
        title: {
          style: {
            color: "#fff",
          },
        },
      },
      plotOptions: {
        series: {
          turboThreshold: 1000000,
          animation: false,
        },
        areaspline: {
          marker: {
            enabled: false,
          },
        },
      },
      legend: {
        itemStyle: {
          color: "#fff",
        },
      },
      tooltip: {
        outside: false,
      },
    },
    selectedHours: {
      id: "1h",
      name: "1 " + this.props.t("dashboard.hour"),
      value: "hour",
    },
    selectedCustom: false,
    refreshIframe: 0,
    isImageDownloading: false,
    themeState:
      document.documentElement.getAttribute("data-theme") === "light"
        ? "light"
        : "dark",
  };

  toggleGraph = () => {
    this.setState({
      showGraph: !this.state.showGraph,
    });
  };

  handleChange = (selectedHours) => {
    this.setState({ selectedHours });
    if (selectedHours.id === "custom") {
      this.props.updateCustomTimeValue();
    }
  };

  componentDidMount() {
    this.handleThemeChange();

    // Update theme color when the theme changes
    window.addEventListener("storage", this.handleThemeChange);
  }

  componentWillUnmount() {
    // Clean up the event listener
    window.removeEventListener("storage", this.handleThemeChange);
  }

  handleThemeChange = () => {
    this.setState({
      themeState:
        document.documentElement.getAttribute("data-theme") === "light"
          ? "light"
          : "dark",
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { timeValue, startDate, endDate } = this.props;

    // if (prevProps.nodate !== this.props.nodate && this.props.nodate) {
    //   this.checkChartLoaded(false);
    // }

    if (prevProps.basicData !== this.props.basicData) {
      this.setState({
        ...this.state,
        basicData: this.props.basicData,
      });
    }

    if (
      prevProps.timeValue !== this.props.timeValue ||
      prevProps.startDate !== startDate
    ) {
      if (timeValue === 5 && this.state.chartOptions.exporting) {
        this.setState((state) => ({
          chartOptions: {
            ...state.chartOptions,
            exporting: {
              ...state.chartOptions.exporting,
              buttons: {
                contextButton: {
                  menuItems: ["viewFullscreen", "printChart"],
                },
              },
            },
          },
        }));
      } else if (timeValue === 6 && this.state.chartOptions.exporting) {
        if (
          startDate.length !== 0 &&
          moment(endDate).diff(moment(startDate), "days") < 6
        ) {
          this.setState((state) => ({
            chartOptions: {
              ...state.chartOptions,
              exporting: {
                ...state.chartOptions.exporting,
                buttons: {
                  contextButton: {
                    menuItems: menuOptions,
                  },
                },
              },
            },
          }));
        } else {
          this.setState((state) => ({
            chartOptions: {
              ...state.chartOptions,
              exporting: {
                ...state.chartOptions.exporting,
                buttons: {
                  contextButton: {
                    menuItems: ["viewFullscreen"],
                  },
                },
              },
            },
          }));
        }
      } else {
        this.setState((state) => ({
          chartOptions: {
            ...state.chartOptions,
            exporting: {
              ...state.chartOptions.exporting,
              buttons: {
                contextButton: {
                  menuItems: menuOptions,
                },
              },
            },
          },
        }));
      }
    }
    if (this.props.task && this.props.task.taskId) {
      if (
        !prevProps.task ||
        !prevProps.task.taskId ||
        prevProps.task.taskId !== this.props.task.taskId
      ) {
        this.handlePolling(this.props.task.taskId);
      }
    }
  }

  handlePolling = async (taskId) => {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    try {
      const headers = getCommonHeaders();
      let url = `${apiPath.baseUrl}${apiPath.auditTrail.task}`;
      url = url.replace("{id}", taskId);
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const result = await response.json();
      if (result.data && result.data.status !== "completed") {
        let status = result.data.status;
        if (result.data.progress) {
          status += " " + result.data.progress + "%";
        }

        this.setState({
          ...this.state,
          downloadPDFStatus: status,
        });
        await delay(5000);
        this.handlePolling(taskId);
      } else if (result.data && result.data.status === "completed") {
        this.setState({
          ...this.state,
          downloadPDFStatus: "",
        });
        window.open(result.data.resultUrl, "_blank");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  checkChartLoaded = (boolean, e) => {
    this.setState({ chartLoaded: boolean });
  };
  componentDidMount() {
    this.chartRef = React.createRef();
    this.iframeRef = React.createRef();
  }

  render() {
    const {
      activeTab,
      // loadingDevices,
      // pagedDeviceMeta,
      // rows,
      deviceAlarmList,
      toggle,
      // afterChartCreated,
      // changePage,
      addDeviceAlarm,
      deviceId,
      basicData,
      t,
    } = this.props;

    const token = localStorage.getItem("token");
    const temperatureUnit = this.props.temperatureUnit;
    const currentDevice = JSON.parse(localStorage.getItem("selectedDevice"));

    const isLightMode =
      document.documentElement.getAttribute("data-theme") === "light";

    const filteredDataStatus =
      basicData &&
      basicData.length > 0 &&
      basicData.filter((eachDevice) => eachDevice.id === deviceId);
    const deviceStatusValue =
      this.props.deviceStatusData && this.props.deviceStatusData.nodeData;
    const filteredBasicData =
      !!filteredDataStatus && filteredDataStatus.length > 0
        ? filteredDataStatus
        : !!deviceStatusValue && [deviceStatusValue];

    const isNodeLiteDevice =
      filteredBasicData.length && filteredBasicData[0].Node_Type;

    if (this.state.showGraph && !isNodeLiteDevice && isNodeLiteDevice !== 1) {
      this.setState({ showGraph: false });
    }

    // const formattedRows =
    //   rows && rows.length
    //     ? rows.map((val) => {
    //         return {
    //           ...val,
    //           bmpS: val.bmpS && val.bmpS !== -255 ? val.bmpS : "N/A",
    //           temperature:
    //             val.temperature && val.temperature !== -255
    //               ? val.temperature
    //               : "N/A",
    //           humidity:
    //             val.humidity && val.humidity !== -255 ? val.humidity : "N/A",
    //           carbon: val.carbon && val.carbon !== -255 ? val.carbon : "N/A",
    //         };
    //       })
    //     : rows;

    // const columns = [
    //   {
    //     label: "Temp (C)",
    //     field: "temperature",
    //     sort: "asc",
    //     width: 100,
    //   },
    //   {
    //     label: "Humidity (%)",
    //     field: "humidity",
    //     sort: "asc",
    //     width: 100,
    //   },
    //   {
    //     label: "CO₂ (%)",
    //     field: "carbon",
    //     sort: "asc",
    //     width: 100,
    //   },
    //   {
    //     label: "Time",
    //     field: "createdAt",
    //     sort: "asc",
    //     width: 150,
    //   },
    // ];
    // const deviceDataRawList = {
    //   columns: columns,
    //   rows: formattedRows,
    // };

    const loadingWrapper = (
      <div className="loadingWrapper">
        <div className="d-flex justify-content-center">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div className="d-flex justify-content-center">
              <LoopCircleLoading />
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <div ref={this.props.scrollRef}>
        <Card
          className="card-default"
          style={{ width: "100%", overflow: "hidden" }}
        >
          <CardHeader className="d-flex align-items-center justify-content-between">
            <CardTitle>
              {currentDevice ? currentDevice.name : "Device Data"}
            </CardTitle>
          </CardHeader>

          <div
            style={{
              height: "1px",
              width: "100%",
              background: "#ccc",
            }}
          />
          <CardBody className="device-data__content">
            <>
              {this.props.loading ? (
                loadingWrapper
              ) : this.props.devices && this.props.devices.length > 0 ? (
                <div className="h-100">
                  <>
                    {/* <HourlyStatus {...this.props} /> */}
                    <TypeNav
                      toggle={toggle}
                      {...this.props}
                      handleChange={this.handleChange}
                      selectedHours={this.state.selectedHours}
                      activeTab={activeTab}
                    />
                    <TabContent
                      activeTab={activeTab}
                      className="graph-pannel"
                      style={{
                        padding: "10px 3px 0px 3px",
                      }}
                    >
                      <TabPane tabId="1">
                        {activeTab === "1" ? (
                          <div
                            className="chartWrapper"
                            style={{ position: "relative" }}
                          >
                            {!!isNodeLiteDevice && isNodeLiteDevice === 1 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "55px",
                                  cursor: "pointer",
                                }}
                                onClick={() => this.toggleGraph()}
                              >
                                {this.state.showGraph ? (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 68 68"
                                    fill={
                                      this.state.themeState === "light"
                                        ? "#6b7280"
                                        : "#fff"
                                    }
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M31.8427 53.781C29.9625 53.1101 28.7148 51.3123 28.7148 49.2746C28.7148 47.3474 29.5152 45.9445 31.1651 44.9806L32.1514 44.4042L32.2426 29.0825C32.2947 20.6556 32.3507 13.743 32.3748 13.7212C32.3944 13.7015 32.6581 13.5564 32.9538 13.4034C33.5646 13.0875 34.0357 13.1813 34.5371 13.7192C34.8757 14.0833 34.8842 14.4221 34.8842 29.2948V44.4984L35.6331 44.8319C37.9673 45.871 39.0651 49.0657 37.884 51.3812C36.7999 53.506 34.0901 54.5825 31.8436 53.7807L31.8427 53.781Z"
                                      fill={
                                        this.state.themeState === "light"
                                          ? "#6b7280"
                                          : "#fff"
                                      }
                                    />
                                    <path
                                      d="M30.7304 60.0143C26.7735 59.057 23.2958 55.5772 22.2682 51.5465C21.9106 50.144 21.9106 47.3601 22.2682 45.9577C22.8445 43.6957 24.3333 41.3311 26.0406 39.9649L26.7322 39.4112V26.0552C26.7322 13.034 26.7517 12.6721 27.106 11.6178C27.7939 9.57597 29.1226 8.17953 31.1208 7.39857C32.5063 6.85738 34.5391 6.86846 35.9944 7.42486C37.4485 7.98167 39.2053 9.72977 39.7998 11.2108L40.2244 12.2683L40.2765 25.7737L40.3286 39.2791L41.7105 40.6816C45.2619 44.2859 46.0686 49.3566 43.8214 53.95C43.2301 55.1592 42.796 55.7377 41.5711 56.9501C39.8935 58.6105 38.2689 59.547 36.2333 60.0268C34.8456 60.3537 32.1081 60.3472 30.7272 60.0134L30.7304 60.0143ZM36.1435 57.122C37.5508 56.6877 39.2001 55.6097 40.1395 54.5114C43.3721 50.7315 42.7878 44.9024 38.8733 41.877C38.2637 41.4061 37.7262 40.9894 37.6776 40.9505C37.632 40.9118 37.5493 34.5156 37.5018 26.7371L37.4132 12.5941L36.8798 11.7316C36.1003 10.471 34.937 9.79974 33.5496 9.81008C31.789 9.82327 30.1771 10.9768 29.7438 12.5339C29.6396 12.9097 29.5719 18.5113 29.5719 26.8673L29.5709 40.5838L29.0779 41.0553C28.8064 41.3145 28.2205 41.8203 27.7758 42.1795C24.6803 44.6801 23.8757 49.6206 25.9795 53.2104C27.9931 56.6463 32.3085 58.3071 36.1445 57.1223L36.1435 57.122Z"
                                      fill={
                                        this.state.themeState === "light"
                                          ? "#6b7280"
                                          : "#fff"
                                      }
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 4096 4096"
                                    version="1.1"
                                  >
                                    <path
                                      d=""
                                      stroke="none"
                                      fill={
                                        this.state.themeState === "light"
                                          ? "#6b7280"
                                          : "#fff"
                                      }
                                      fill-rule="evenodd"
                                    />
                                    <path
                                      d="M 2025.555 385.614 C 2015.820 387.371, 1999.338 392.802, 1990.829 397.056 C 1960.615 412.160, 1937.293 439.020, 1926.588 471.041 C 1919.389 492.573, 1920 435.989, 1920 1081.631 L 1920 1664 1782.131 1664 C 1629.619 1664, 1636.560 1663.728, 1616.329 1670.492 C 1598.039 1676.606, 1582.855 1685.648, 1569.015 1698.668 C 1548.853 1717.635, 1535.459 1742.546, 1530.496 1770.307 C 1527.732 1785.771, 1528.757 1808.686, 1532.919 1824.464 C 1536.357 1837.495, 1542.269 1850.962, 1549.252 1861.664 C 1551.705 1865.424, 1642.177 1992.250, 1750.301 2143.500 C 1890.904 2340.184, 1949.255 2421.045, 1955.195 2427.436 C 1997.753 2473.225, 2067.749 2481.317, 2120 2446.487 C 2128.642 2440.727, 2138.696 2431.898, 2145.201 2424.358 C 2150.013 2418.781, 2537.620 1877.552, 2547.873 1862.094 C 2561.455 1841.617, 2568.368 1817.976, 2568.368 1792 C 2568.368 1755.773, 2555.157 1724.753, 2529.062 1699.706 C 2510.305 1681.703, 2489.378 1670.872, 2463.754 1665.905 C 2454.384 1664.088, 2447.501 1664, 2314.965 1664 L 2176 1664 2176 1081.631 C 2176 560.819, 2175.837 498.323, 2174.454 490.381 C 2166.337 443.739, 2133.581 405.505, 2088.959 390.588 C 2083.207 388.665, 2074.504 386.396, 2069.619 385.546 C 2058.575 383.623, 2036.390 383.658, 2025.555 385.614 M 3269.500 2049.584 C 3073.749 2067.206, 2903.012 2183.204, 2815.476 2358.048 C 2804.435 2380.101, 2800.567 2389.591, 2797.264 2402.726 C 2794.804 2412.508, 2794.555 2415.204, 2794.555 2432 C 2794.555 2448.796, 2794.804 2451.492, 2797.264 2461.274 C 2805.469 2493.904, 2823.929 2520.527, 2850.713 2538.358 C 2872.948 2553.160, 2895.477 2560, 2922 2560 C 2957.700 2560, 2987.939 2547.409, 3013.007 2522.105 C 3025.957 2509.034, 3030.128 2502.804, 3042.894 2477.471 C 3054.315 2454.806, 3062.181 2441.860, 3074.342 2425.713 C 3124.852 2358.645, 3200.952 2315.511, 3285.500 2306.026 C 3298.684 2304.547, 3306.033 2304.761, 3319.931 2307.029 C 3469.831 2331.486, 3578.390 2466.387, 3569.953 2617.716 C 3568.557 2642.750, 3567.555 2648.272, 3562.548 2658.500 C 3549.703 2684.738, 3532.331 2708.699, 3509.541 2731.612 C 3486.425 2754.853, 3463.451 2771.301, 3433.500 2786.051 C 3397.830 2803.617, 3363.920 2812.490, 3322.924 2814.983 C 3312.118 2815.640, 2804.460 2815.985, 1838.881 2815.991 C 519.582 2815.999, 370.364 2816.156, 362.381 2817.546 C 322.283 2824.524, 287.172 2850.590, 269.056 2886.829 C 264.608 2895.725, 259.368 2911.911, 257.546 2922.381 C 255.565 2933.762, 255.565 2954.238, 257.546 2965.619 C 265.663 3012.261, 298.419 3050.495, 343.041 3065.412 C 348.793 3067.335, 357.496 3069.604, 362.381 3070.454 C 370.365 3071.844, 520.835 3072, 1851.931 3072 C 2865.673 3072, 3336.842 3071.673, 3346.050 3070.962 C 3379.173 3068.406, 3407.211 3063.969, 3437.805 3056.440 C 3590.589 3018.840, 3719.774 2916.079, 3790.987 2775.500 C 3802.430 2752.911, 3810.268 2734.690, 3813.565 2723.014 C 3818.405 2705.873, 3823.852 2669.651, 3825.973 2640.500 C 3827.283 2622.504, 3827.283 2581.496, 3825.973 2563.500 C 3817.224 2443.254, 3772.300 2333.741, 3693.314 2240.111 C 3680.796 2225.273, 3650.003 2194.379, 3634.500 2181.105 C 3556.239 2114.096, 3460.855 2069.615, 3361 2053.563 C 3325.125 2047.796, 3301.013 2046.748, 3269.500 2049.584 M 361.555 3201.614 C 351.820 3203.371, 335.338 3208.802, 326.829 3213.056 C 296.615 3228.160, 273.293 3255.020, 262.588 3287.041 C 257.869 3301.156, 256 3312.777, 256 3328 C 256 3361.342, 268.062 3391.955, 290.668 3415.985 C 309.341 3435.835, 335.248 3449.732, 362.381 3454.454 C 370.368 3455.844, 540.045 3456, 2048 3456 C 3555.955 3456, 3725.632 3455.844, 3733.619 3454.454 C 3773.717 3447.476, 3808.828 3421.410, 3826.944 3385.171 C 3831.392 3376.275, 3836.632 3360.089, 3838.454 3349.619 C 3840.435 3338.238, 3840.435 3317.762, 3838.454 3306.381 C 3830.337 3259.739, 3797.581 3221.505, 3752.959 3206.588 C 3747.207 3204.665, 3738.504 3202.396, 3733.619 3201.546 C 3725.631 3200.155, 3556.131 3200.009, 2047.119 3200.090 C 594.695 3200.167, 368.433 3200.372, 361.555 3201.614 M 361.555 3585.614 C 351.820 3587.371, 335.338 3592.802, 326.829 3597.056 C 296.615 3612.160, 273.293 3639.020, 262.588 3671.041 C 257.869 3685.156, 256 3696.777, 256 3712 C 256 3745.342, 268.062 3775.955, 290.668 3799.985 C 309.341 3819.835, 335.248 3833.732, 362.381 3838.454 C 370.368 3839.844, 540.045 3840, 2048 3840 C 3555.955 3840, 3725.632 3839.844, 3733.619 3838.454 C 3773.717 3831.476, 3808.828 3805.410, 3826.944 3769.171 C 3831.392 3760.275, 3836.632 3744.089, 3838.454 3733.619 C 3840.435 3722.238, 3840.435 3701.762, 3838.454 3690.381 C 3830.337 3643.739, 3797.581 3605.505, 3752.959 3590.588 C 3747.207 3588.665, 3738.504 3586.396, 3733.619 3585.546 C 3725.631 3584.155, 3556.131 3584.009, 2047.119 3584.090 C 594.695 3584.167, 368.433 3584.372, 361.555 3585.614"
                                      stroke="none"
                                      fill={
                                        this.state.themeState === "light"
                                          ? "#6b7280"
                                          : "#fff"
                                      }
                                      fill-rule="evenodd"
                                    />
                                  </svg>
                                )}
                              </div>
                            )}
                            <span
                              className="fas fa-sync"
                              style={{
                                position: "absolute",
                                right: "13px",
                                top: "3px",
                                cursor: "pointer",
                                color:
                                  this.state.themeState === "light"
                                    ? "#6b7280"
                                    : "#fff",
                              }}
                              onClick={() => {
                                this.setState({
                                  refreshIframe: this.state.refreshIframe + 1,
                                });
                              }}
                            ></span>
                            <span
                              className={
                                this.state.isImageDownloading
                                  ? "fas fa-spinner fa-spin"
                                  : "fas fa-image"
                              }
                              style={{
                                position: "absolute",
                                right: "13px",
                                top: "33px",
                                cursor: "pointer",
                                color:
                                  this.state.themeState === "light"
                                    ? "#6b7280"
                                    : "#fff",
                              }}
                              onClick={() => {
                                try {
                                  if (this.state.isImageDownloading) return;
                                  var href = this.iframeRef.current
                                    .contentWindow.location.href;
                                  this.setState({ isImageDownloading: true });
                                  fetch(
                                    href.replace("/d-solo/", "/render/d-solo/")
                                  )
                                    .then((response) => response.blob())
                                    .then((blob) => {
                                      const blobURL = URL.createObjectURL(blob);
                                      const a = document.createElement("a");
                                      a.href = blobURL;
                                      a.style = "display: none";

                                      a.download = "grafana-chart-snapshot";
                                      document.body.appendChild(a);
                                      a.click();
                                      this.setState({
                                        isImageDownloading: false,
                                      });
                                    })
                                    .catch(() => console.error(true));
                                  //window.open(href.replace('/d-solo/', '/render/d-solo/'), '_blank');
                                } catch (e) {
                                  console.error(e);
                                }
                              }}
                            ></span>
                            {!!isNodeLiteDevice && isNodeLiteDevice === 2 ? (
                              <iframe
                                title="grafana-chart-snapshot"
                                sandbox
                                ref={this.iframeRef}
                                key={this.state.refreshIframe}
                                onload="this.contentDocument.body.style.border='1px solid red';"
                                src={`${
                                  apiPath.baseGraphanaUrl
                                }orgId=1&var-deviceId=${deviceId}&from=${
                                  this.state.selectedHours.id === "custom"
                                    ? Date.parse(this.props.startDate)
                                    : `now-${this.state.selectedHours.id}`
                                }&to=${
                                  this.state.selectedHours.id === "custom"
                                    ? Date.parse(this.props.endDate)
                                    : "now"
                                }&var-from=${
                                  this.state.selectedHours.id === "custom"
                                    ? `'${moment(this.props.startDate).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}'`
                                    : `now()-${this.state.selectedHours.id}`
                                }&var-to=${
                                  this.state.selectedHours.id === "custom"
                                    ? `'${moment(this.props.endDate).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}'`
                                    : "now()"
                                }&var-auth_token=${token}&panelId=${"14"}&refresh=30s&var-temperatureUnit=${
                                  temperatureUnit === "Celsius"
                                    ? "(°C)"
                                    : "(°F)"
                                }&var-type=${
                                  process.env.REACT_APP_NODE_ENV === "PRE-LIVE"
                                    ? "preLive"
                                    : "prod"
                                }&theme=${isLightMode ? "light" : "dark"}`}
                                width="100%"
                                height="400"
                                frameborder="0"
                              ></iframe>
                            ) : (
                              <iframe
                                title="grafana-chart-snapshot"
                                sandbox
                                ref={this.iframeRef}
                                key={this.state.refreshIframe}
                                onload="this.contentDocument.body.style.border='1px solid red';"
                                src={`${
                                  apiPath.baseGraphanaUrl
                                }orgId=1&var-deviceId=${deviceId}&from=${
                                  this.state.selectedHours.id === "custom"
                                    ? Date.parse(this.props.startDate)
                                    : `now-${this.state.selectedHours.id}`
                                }&to=${
                                  this.state.selectedHours.id === "custom"
                                    ? Date.parse(this.props.endDate)
                                    : "now"
                                }&var-from=${
                                  this.state.selectedHours.id === "custom"
                                    ? `'${moment(this.props.startDate).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}'`
                                    : `now()-${this.state.selectedHours.id}`
                                }&var-to=${
                                  this.state.selectedHours.id === "custom"
                                    ? `'${moment(this.props.endDate).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}'`
                                    : "now()"
                                }&var-auth_token=${token}&panelId=${
                                  this.state.showGraph ? "12" : "1"
                                }&refresh=30s&var-temperatureUnit=${
                                  temperatureUnit === "Celsius"
                                    ? "(°C)"
                                    : "(°F)"
                                }&var-type=${
                                  process.env.REACT_APP_NODE_ENV === "PRE-LIVE"
                                    ? "preLive"
                                    : "prod"
                                }&theme=${isLightMode ? "light" : "dark"}`}
                                width="100%"
                                height="400"
                                frameborder="0"
                              ></iframe>
                            )}
                          </div>
                        ) : null}
                      </TabPane>
                      <TabPane tabId="2">
                        {activeTab === "2" ? (
                          <div className="rawTable" style={{ height: "auto" }}>
                            <Row className="mb-3">
                              <Col xl={4} lg={12} md={4}>
                                <div className="mb-2 ml-2">
                                  <button
                                    onClick={() => {
                                      const splittedValue = this.state.selectedHours.id.split(
                                        ""
                                      );
                                      this.props.downloadRawDataDownload({
                                        deviceId,
                                        from:
                                          this.state.selectedHours.id ===
                                          "custom"
                                            ? moment(
                                                this.props.startDate
                                              ).toISOString()
                                            : // format("YYYY-MM-DD")
                                              moment().subtract(
                                                splittedValue[0],
                                                splittedValue[1]
                                              ),
                                        // `now()-${this.state.selectedHours.id}`,
                                        to:
                                          this.state.selectedHours.id ===
                                          "custom"
                                            ? moment(
                                                this.props.endDate
                                              ).toISOString()
                                            : // format(
                                              //     "YYYY-MM-DD"
                                              //   )
                                              moment().toISOString(),
                                        // `now()`,
                                        format: "pdf",
                                        type: "raw_data",
                                        timezone: moment.tz.guess(),
                                      });
                                    }}
                                    type="button"
                                    className="btn btn-info pull-right"
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-download"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    PDF
                                  </button>
                                  <button
                                    onClick={() => {
                                      const splittedValue = this.state.selectedHours.id.split(
                                        ""
                                      );
                                      this.props.downloadRawDataDownload({
                                        deviceId,
                                        from:
                                          this.state.selectedHours.id ===
                                          "custom"
                                            ? moment(
                                                this.props.startDate
                                              ).toISOString()
                                            : // format("YYYY-MM-DD")
                                              moment().subtract(
                                                splittedValue[0],
                                                splittedValue[1]
                                              ),
                                        // `now()-${this.state.selectedHours.id}`,
                                        to:
                                          this.state.selectedHours.id ===
                                          "custom"
                                            ? moment(
                                                this.props.endDate
                                              ).toISOString()
                                            : // format(
                                              //     "YYYY-MM-DD"
                                              //   )
                                              moment().toISOString(),
                                        // `now()`,
                                        format: "csv",
                                        type: "raw_data",
                                        timezone: moment.tz.guess(),
                                      });
                                    }}
                                    type="button"
                                    className="btn btn-info pull-right"
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-download"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    CSV
                                  </button>
                                </div>
                              </Col>
                            </Row>
                            <iframe
                              title="grafana-raw-chart"
                              src={`${
                                apiPath.baseGraphanaUrl
                              }orgId=1&var-deviceId=${deviceId}&from=${
                                this.state.selectedHours.id === "custom"
                                  ? this.props.startDate
                                  : `now-${this.state.selectedHours.id}`
                              }&to=${
                                this.state.selectedHours.id === "custom"
                                  ? this.props.endDate
                                  : "now"
                              }&var-from=${
                                this.state.selectedHours.id === "custom"
                                  ? `'${moment(this.props.startDate).format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    )}'`
                                  : `now()-${this.state.selectedHours.id}`
                              }&var-to=${
                                this.state.selectedHours.id === "custom"
                                  ? `'${moment(this.props.endDate).format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    )}'`
                                  : "now()"
                              }&var-auth_token=${token}&panelId=${
                                !!isNodeLiteDevice && isNodeLiteDevice === 2
                                  ? "15"
                                  : "2"
                              }&refresh=30s&var-temperatureUnit=${
                                temperatureUnit === "Celsius" ? "(°C)" : "(°F)"
                              }&var-type=${
                                process.env.REACT_APP_NODE_ENV === "PRE-LIVE"
                                  ? "preLive"
                                  : "prod"
                              }&theme=${isLightMode ? "light" : "dark"}`}
                              width="100%"
                              height="400"
                              frameborder="0"
                            ></iframe>
                          </div>
                        ) : null}
                      </TabPane>
                      <TabPane tabId="3">
                        {activeTab === "3" ? (
                          <>
                            {/* {userRole === 'super_user' && ( */}
                            <Button
                              color="info"
                              onClick={addDeviceAlarm}
                              className="ml-2"
                            >
                              {t("dashboard.addAlarm")}
                            </Button>
                            {/* )} */}
                            <div className="device-alram-detail locations p-4 d-flex flex-wrap">
                              {deviceAlarmList.length ? (
                                deviceAlarmList.map((alarm, index) => (
                                  <Alarm
                                    {...this.props}
                                    alarm={alarm}
                                    index={index}
                                    key={index}
                                    profileId={alarm.profileId}
                                    isNodeLiteDevice={
                                      isNodeLiteDevice && isNodeLiteDevice === 2
                                    }
                                  />
                                ))
                              ) : (
                                <p>{t("dashboard.noAlarmsAddedYet")}</p>
                              )}
                            </div>
                          </>
                        ) : null}
                      </TabPane>
                    </TabContent>
                  </>
                </div>
              ) : (
                <div className="d-flex flex-column justify-content-center h-100 device-data__content">
                  <div className="d-flex justify-content-center">
                    <img
                      width={72}
                      height={72}
                      src="img/warning.png"
                      alt="warning"
                    />
                  </div>
                  <div className="mt-4 d-flex justify-content-center">
                    <h4 className="text-center">
                      {t("dashboard.noDevicesYet")}.
                    </h4>
                  </div>
                </div>
              )}
            </>
            {/* )}
            </> */}
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    startDate: state.locationsDevices.startDate,
    endDate: state.locationsDevices.endDate,
    nodate: state.locationsDevices.nodate,
    exceeded: state.locationsDevices.exceeded,
    devices: state.locationsDevices.devices,
    loading: state.locationsDevices.loading,
    loadingDevices: state.locationsDevices.loadingDevices,
    pagedDeviceMeta: state.locationsDevices.pagedDeviceMeta,
    deviceDataList: state.locationsDevices.deviceDataList,
    graphLoading: state.locationsDevices.graphLoading,
    deviceStatusData: state.dashboard.deviceStatus,
    temperatureUnit: state.auth.temperatureUnit,
    task: state.auditTrail.task,
    // pagedDeviceDataList: state.locationsDevices.pagedDeviceDataList,
    // deviceAlarmList: state.deviceAlarms.deviceAlarmList,
    // reloadAlarms: state.deviceAlarms.reload,
    // recentAlarms: state.deviceAlarms.recentAlarms,
    // showGraph: state.locationsDevices.showGraph,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloadRawDataDownload: (payload) =>
      dispatch(actions.pdfExportAuditTrail(payload)),
    // dispatch(actions.getDownloadRawData(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(DeviceData));
